export default [
    {
        dataField: 'orgID',
        cols: 1,
        rows: 1,
        text: 'id организации',
        order: 0,
        variable: true,
        template: (row) => {
            return row?.id ?? '';
        }
    },
    {
        dataField: 'orgName',
        cols: 3,
        rows: 1,
        text: 'Наименование организации / филиала',
        order: 1,
        variable: true,
        template: (row) => {
            return row.name;
        }
    },
    // {
    //     dataField: 'sumKcp',
    //     cols: 1,
    //     rows: 1,
    //     text: 'Распределение мест',
    //     order: 3,
    //     variable: true,
    //     template: (row) => {
    //         return row.sumKcp ?? '-';
    //     }
    // },
    // {
    //     dataField: 'sumPlaces',
    //     cols: 1,
    //     rows: 1,
    //     text: 'значения',
    //     order: 4,
    //     variable: true,
    //     template: (row) => {
    //         return row.sumPlaces ?? '-';
    //     }
    // },
    {
        dataField: 'block',
        cols: 1,
        rows: 1,
        text: 'Статус',
        order: 5,
        variable: true,
        class: 'd-flex flex-row align-center',
        template: (row) => {
            return row.block ? 'Заблокирован' : 'Не заблокирован';
        }
    },
]